import { useToast, TYPE, POSITION } from "vue-toastification";

const toast = useToast();

export type AlertId = ReturnType<typeof toast>;
type AlertOverrides = Omit<
  NonNullable<Parameters<typeof toast>[1]>,
  "type" | "id"
>;

export function showAlert(
  type: TYPE,
  message: string,
  overrides?: AlertOverrides
): AlertId {
  return toast(message, {
    position: POSITION.TOP_CENTER,
    timeout: 3000,
    closeOnClick: true,
    pauseOnFocusLoss: false,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    ...overrides,
    type,
  });
}

export function dismissAlert(id: AlertId): void {
  toast.dismiss(id);
}
